import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-635a1bf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "participants-title" }
const _hoisted_3 = { class: "counter" }
const _hoisted_4 = {
  key: 0,
  class: "empty"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["data-id"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { class: "dialog-content pb-6 mt-4" }

import { useDialogStore } from '@/stores/dialogs';
import { computed, nextTick, reactive, ref } from 'vue';
import { nanoid } from 'nanoid'
import { useProgramsStore } from '@/stores/programs';
import VDialogHeader from './VDialogHeader.vue';
import emptySvg from '@/assets/empty.svg'
import { name } from '@/utils/name';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddProgramDialog',
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as { program?: any }



const containerRef = ref<HTMLDivElement>()
const programsStore = useProgramsStore()
const dialogStore = useDialogStore()
const pending = ref(false)
const programName = ref(props.program?.name || "")

const students = reactive<{ id: string, name: string, avatar?: { src: string, file?: File } }[]>([])
const fileRef = ref<HTMLInputElement>()
if (props.program) {
  programsStore.requestStudents(props.program.id).then(() => {
    for (let student of props.program.students) {
      students.push({ id: student.id, name: name(student), avatar: student.avatar? { src: student.avatar }: undefined })
    }
  })
}

const visualStudents = computed(() => {
  const val = searchValue.value.toLowerCase().trim()
  if (val.length === 0) return students
  return students.filter(user => user.name.toLowerCase().includes(val))
})

const addStudent = () => {
  searchValue.value = ""
  const student = { id: nanoid(), name: "" }
  students.unshift(student)
  nextTick(() => {
    const input = containerRef.value?.querySelector(`.participant-row[data-id="${student.id}"] input`) as HTMLInputElement
    input?.focus()
  })
}

const deleteStudent = (id: string) => {
  students.splice(students.findIndex(s => s.id === id), 1)
}

const apply = async () => {
  pending.value = true
  try {
    if (props.program) {
      await programsStore.editProgram(props.program.id, programName.value, students)
    } else {
      await programsStore.addProgram(programName.value, students)
    }
    dialogStore.close()
  } catch(e) {
    console.log(e)
    pending.value = false
  }
}

let fileChangeEvent = (file: File) => {}
const onFileChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files
  if (!files || !files[0]) return
  fileChangeEvent(files[0])
}

const setAvatar = async (userId: string) => {
  fileChangeEvent = (file) => {
    const student = students.find(item => item.id === userId)!
    student.avatar = { src: URL.createObjectURL(file), file: file }
  }
  fileRef.value?.click()
}

const searchValue = ref("")


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_badge = _resolveComponent("v-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.program)
      ? (_openBlock(), _createBlock(VDialogHeader, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("Редактирование программы «" + _toDisplayString(props.program.name) + "»", 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(VDialogHeader, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("Добавление программы")
          ]),
          _: 1
        })),
    _createElementVNode("div", {
      ref_key: "containerRef",
      ref: containerRef,
      class: "dialog-content pt-6 scroll container"
    }, [
      _createVNode(_component_v_text_field, {
        modelValue: programName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((programName).value = $event)),
        label: "Название программы",
        variant: "outlined",
        style: {"flex-grow":"0"}
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_text_field, {
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
          "prepend-inner-icon": "mdi-magnify",
          placeholder: "Поиск участника",
          variant: "outlined",
          class: "search-input"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_btn, {
          "prepend-icon": "mdi-plus",
          color: "primary",
          class: "add-button",
          onClick: addStudent
        }, {
          default: _withCtx(() => [
            _createTextVNode("Добавить участника")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" Участники "),
        _createElementVNode("span", _hoisted_3, _toDisplayString(students.length), 1)
      ]),
      (students.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(emptySvg),
              alt: "empty"
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visualStudents), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "participant-row",
          "data-id": item.id
        }, [
          _createVNode(_component_v_badge, {
            icon: "mdi-pencil",
            location: "bottom end",
            color: "primary",
            "offset-x": "14",
            onClick: ($event: any) => (setAvatar(item.id))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_avatar, {
                color: "grey-lighten-1 mr-3",
                size: "30",
                image: item.avatar?.src
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "white",
                    size: "x-small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-account")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["image"])
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
            placeholder: "Имя студента"
          }, null, 8, _hoisted_7), [
            [_vModelText, item.name]
          ]),
          _createVNode(_component_v_btn, {
            icon: "mdi-delete",
            variant: "flat",
            onClick: ($event: any) => (deleteStudent(item.id))
          }, null, 8, ["onClick"])
        ], 8, _hoisted_6))
      }), 128))
    ], 512),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(dialogStore).close())),
        variant: "tonal",
        class: "mr-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отменить ")
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: apply,
        disabled: pending.value || programName.value === ''
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Сохранить ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("input", {
      ref_key: "fileRef",
      ref: fileRef,
      type: "file",
      accept: "image/*",
      class: "d-none",
      onChange: onFileChange
    }, null, 544)
  ], 64))
}
}

})